export default __webpack_public_path__ + "static/media/close.c6e3bcfa.svg";